/**
 * src/lib/captcha.ts
 * =============================================================================
 * Resuelve el captcha invisible (ALTCHA) que exige la API antes de mandar un
 * correo: registro y "he olvidado mi contraseña". Ver backend/src/lib/captcha.ts
 * para el porqué (registros falsos con correos de víctimas, octubre 2026).
 *
 * Pide un reto firmado a `/captcha/reto`, prueba contadores con PBKDF2 de
 * WebCrypto hasta dar con el bueno (~150 ms en un portátil, ~1 s en un móvil
 * modesto) y devuelve la solución empaquetada para la cabecera `x-altcha`.
 * Nada sale a terceros ni deja cookies. Cada solución vale UNA vez.
 * =============================================================================
 */

import { solveChallenge, type Challenge } from 'altcha-lib'
import { deriveKey } from 'altcha-lib/algorithms/web/pbkdf2'
import { api } from '@/lib/api'

export async function resolverCaptcha(): Promise<string> {
  const challenge = await api<Challenge>('/captcha/reto', { credentials: false })
  const solution = await solveChallenge({ challenge, deriveKey, timeout: 60_000 })
  if (!solution) throw new Error('captcha_timeout')
  return btoa(JSON.stringify({ challenge, solution }))
}
